import Entity from './entity'

export default class LeaveMessage extends Entity<string>{
    //留言内容
    content: string;
    // 目标用户
    targetUserId: number;
    // 标题
    title: string;
    //是否审核
    isAudited: boolean;
}